// Progress percentages for each screen in the CHOOSING_YOUR_DOG section
const choosingYourDogProgress: Record<ChoosingYourDogScreenNames, number> = {
	CYD_INTRO: 0,
	Q8: 0,
	Q9: 20,
	Q10: 40,
	Q10_1: 50,
	Q11: 75,
	Q11_1: 85,
	Q11_2: 90,
};

export const getNextScreenChoosingYourDog = (
	surveyState: NDS.SurveyState,
	formData: NDS.FormData,
	questionSchema: NDS.QuestionSchema,
): NDS.RouteChange => {
	const screenState = surveyState.routeStack[surveyState.routeStack.length - 1];

	switch (screenState.screen as ChoosingYourDogScreenNames) {
		// Choosing your dog
		case "CYD_INTRO": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				CHOOSING_YOUR_DOG: choosingYourDogProgress.Q8,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "CHOOSING_YOUR_DOG",
				screen: "Q8",
			});

			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// When did you get [dogName]?
		case "Q8": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				CHOOSING_YOUR_DOG: choosingYourDogProgress.Q9,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "CHOOSING_YOUR_DOG",
				screen: "Q9",
			});

			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Where did you get [dogName] from?
		case "Q9": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				CHOOSING_YOUR_DOG: choosingYourDogProgress.Q10,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "CHOOSING_YOUR_DOG",
				screen: "Q10",
			});

			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Where did you first see or hear about [dogName]?
		case "Q10": {
			const generalSellingIndex = 3;
			const petSellingIndex = 4;
			const socialMediaSellingIndex = 6;

			const userAnswer = formData.nds_q_10_how_found_1 as string;

			const generalSellingAnswer =
				questionSchema.CHOOSING_YOUR_DOG.Q10.fields[0].options[
					generalSellingIndex
				].value;

			const petSellingAnswer =
				questionSchema.CHOOSING_YOUR_DOG.Q10.fields[0].options[petSellingIndex]
					.value;

			const socialMediaSellingAnswer =
				questionSchema.CHOOSING_YOUR_DOG.Q10.fields[0].options[
					socialMediaSellingIndex
				].value;

			const progressToQ10_1_Answers = [
				generalSellingAnswer,
				petSellingAnswer,
				socialMediaSellingAnswer,
			];
			// We want to find out more if they first saw the dog on general selling sites, pet selling sites, or social media
			if (progressToQ10_1_Answers.includes(userAnswer)) {
				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					CHOOSING_YOUR_DOG: choosingYourDogProgress.Q10_1,
				};
				surveyState.routeStack.push({
					...screenState,
					route: "CHOOSING_YOUR_DOG",
					screen: "Q10_1",
				});

				return {
					surveyState,
					formData,
				};
			}
			// Otherwise go to the research question
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				CHOOSING_YOUR_DOG: choosingYourDogProgress.Q11,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "CHOOSING_YOUR_DOG",
				screen: "Q11",
			});

			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// If you can remember, please tell us which <how_found> you first saw or heard about [dogName] on.
		case "Q10_1": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				CHOOSING_YOUR_DOG: choosingYourDogProgress.Q11,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "CHOOSING_YOUR_DOG",
				screen: "Q11",
			});

			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// What research did you do before you brought [dogName] home?
		case "Q11": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				CHOOSING_YOUR_DOG: choosingYourDogProgress.Q11_1,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "CHOOSING_YOUR_DOG",
				screen: "Q11_1",
			});

			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// How important were the following things when deciding to get [dogName]?
		case "Q11_1": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				CHOOSING_YOUR_DOG: choosingYourDogProgress.Q11_2,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "CHOOSING_YOUR_DOG",
				screen: "Q11_2",
			});

			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Is there anything else you'd like to share about getting your dog?
		case "Q11_2": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				CHOOSING_YOUR_DOG: 100,
				UNDERSTANDING_YOUR_DOG: 0,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "UNDERSTANDING_YOUR_DOG",
				screen: "UYD_INTRO",
			});

			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
				transition: "CHOOSING_YOUR_DOG",
			};
		}
	}
};
